import { INotAppFriendRaw } from '@base/api';

import { IAppFriend, IAppRequestResponse } from '@interfaces';

export const formatFriendsResponse = (
	rawFriendsResponse: INotAppFriendRaw[],
): IAppFriend[] =>
	rawFriendsResponse.map((rawFriendData) => ({
		avatar: rawFriendData.pic,
		name: `${rawFriendData.first_name} ${rawFriendData.last_name}`,
		uid: rawFriendData.uid,
	}));

export const formatAppResponse = (
	rawAppResponse: IAppRequestResponse,
) => ({
	id: rawAppResponse.ID,
	name: rawAppResponse.Name,
	privateKey: rawAppResponse.pk,
	useJSAPI: Boolean(rawAppResponse.MobileCanvas),
	url: rawAppResponse.redirect_url,
});
